import { inject, Pipe, PipeTransform } from "@angular/core";
import { LanguageService } from "../services/language.service";

@Pipe({
  name: "trans",
  pure: false,
  standalone: true,
})
export class TranslatePipe implements PipeTransform {
  private languageService = inject(LanguageService);
  private argsKey = "#";
  private cache = new Map<string, string>();
  private cachedLang: string | null = null;

  transform(value: any, args?: { count?: number; [key: string]: any }): string {
    if (!value) {
      return "";
    }

    const lang = this.languageService.currentLang();
    if (lang !== this.cachedLang) {
      this.cache.clear();
      this.cachedLang = lang;
    }

    const cacheKey = args ? `${value}:${JSON.stringify(args)}` : value;
    const cached = this.cache.get(cacheKey);
    if (cached !== undefined) {
      return cached;
    }

    const messages = this.languageService.messages();

    // Gestion du pluriel : si count > 1, cherche la clé _plural
    let key = value;
    if (args?.count !== undefined && args.count > 1) {
      key = `${value}_plural`;
    }

    const splitMessage: string[] = key.split(".");
    let message = this.readMessage(splitMessage, 0, messages);

    // Fallback sur la clé originale si _plural n'existe pas
    if (!message && key !== value) {
      const fallbackSplit: string[] = value.split(".");
      message = this.readMessage(fallbackSplit, 0, messages);
    }

    if (!message) {
      this.cache.set(cacheKey, value);
      return value;
    }

    if (args) {
      const keys = Object.keys(args);
      for (const argKey of keys) {
        message = message.replace(`${this.argsKey}${argKey}`, String(args[argKey]));
      }
    }

    this.cache.set(cacheKey, message);
    return message;
  }

  private readMessage(params: string[], index: number, response: any): any {
    if (params.length === index) {
      return response;
    }

    const message = response[params[index]];
    if (!message) {
      return message;
    }

    return this.readMessage(params, index + 1, message);
  }
}
